// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Logo_wrapper__3qbEA","scrolled":"Logo_scrolled__23Vp0","logo":"Logo_logo__3noLJ","inverted":"Logo_inverted__3-ns2","slogan":"Logo_slogan__m5LTS"};